import script from "./Footer.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=76ce221c&lang=scss&scoped=true"

import exportComponent from "/Users/clopez/Documents/Repositorios/Muevetec/landing-muevetec-base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ce221c"]])

export default __exports__